import { mapGetters } from 'vuex'

export const textVariables = {
  data: () => ({
    hasVariableErrors: false,
  }),
  computed: {
    ...mapGetters(['mariaCampaign']),
    variables() {
      if (this.messageVariablesDisabled) return []
      return ['[primeiro nome]', '[ultimo nome]', '[data hoje]', '[dia aniversario]', '[mes]']
    },
    superVariables() {
      if (this.messageVariablesDisabled) return []
      const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
      const product = offerType !== 'combo' ? 'produto' : 'combo'
      return [`[primeiro melhor ${product} `, `[segundo melhor ${product} `, `[terceiro melhor ${product} `]
    },
    insideVariables() {
      if (this.messageVariablesDisabled) return []
      const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
      switch (offerType) {
        case 'general':
          return ['{nome produto}', '{preço 1}', '{preço 2}', '{inicio validade}', '{fim validade}']
        case 'percentage':
          return ['{nome produto}', '{desconto}', '{inicio validade}', '{fim validade}']
        case 'takepay':
          return ['{nome produto}', '{leve}', '{pague}', '{inicio validade}', '{fim validade}']
        case 'combo':
          return ['{nome produto}', '{nome do combo}', '{inicio validade}', '{fim validade}']
      }
    },
  },
  methods: {
    getRevisedText(text) {
      let hasVariableErrors = false
      if (text) {
        const offerType = this.mariaCampaign && this.mariaCampaign.offerType ? this.mariaCampaign.offerType : 'general'
        let theBestProductsRegex
        if (offerType !== 'combo') {
          theBestProductsRegex = [
            text.match(/(\[primeiro melhor produto )[^\][]*(])/g),
            text.match(/(\[segundo melhor produto )[^\][]*(])/g),
            text.match(/(\[terceiro melhor produto )[^\][]*(])/g),
          ].filter((rx) => rx)
        } else {
          theBestProductsRegex = [
            text.match(/(\[primeiro melhor combo )[^\][]*(])/g),
            text.match(/(\[segundo melhor combo )[^\][]*(])/g),
            text.match(/(\[terceiro melhor combo )[^\][]*(])/g),
          ].filter((rx) => rx)
        }

        let variablesRegex = text.match(/(\[)[^\][]*(])/g)

        const verifyInsideVariables = (bestRegex) => {
          if (variablesRegex) {
            variablesRegex.forEach((matchVariables) => {
              if (!theBestProductsRegex.find((bx) => bx.includes(matchVariables))) {
                let variablesFormatted = matchVariables
                let variables = [...this.variables, ...this.superVariables]
                let isValid = false

                // Check if matchVariables is a valid variable
                variables.forEach((variable) => {
                  if (matchVariables === variable) {
                    isValid = true
                  }
                })

                if (!isValid) {
                  hasVariableErrors = true
                  variablesFormatted = `<span class="variable-error-super">${matchVariables}</span>`
                }

                text = text.replace(matchVariables, variablesFormatted)
              }
            })
          }

          if (bestRegex) {
            bestRegex.forEach((matchBest) => {
              const insideVariablesRegex = matchBest.match(/(\{)[^}{]*(})/g)
              if (insideVariablesRegex) {
                insideVariablesRegex.forEach((matchInsideVariables) => {
                  let isValidInside = false
                  this.insideVariables.forEach((insideVariable) => {
                    if (matchInsideVariables === insideVariable) {
                      isValidInside = true
                    }
                  })

                  if (!isValidInside) {
                    hasVariableErrors = true
                    const formatted = `<span class="variable-error">${matchInsideVariables}</span>`
                    text = text.replace(matchInsideVariables, formatted)
                  }
                })
              }
            })
          }
        }

        if (theBestProductsRegex.length) theBestProductsRegex.forEach((bestRegex) => verifyInsideVariables(bestRegex))
        else {
          if (variablesRegex) {
            const variables = [...this.variables, ...this.superVariables]
            variablesRegex.forEach((matchedVariable) => {
              if (!variables.includes(matchedVariable)) {
                hasVariableErrors = true
                text = text.replaceAll(matchedVariable, `<span class="variable-error">${matchedVariable}</span>`)
              }
            })
          }
        }

        const includeInsideVariables = theBestProductsRegex.length ? [...this.insideVariables, ...this.superVariables] : []

        if (text) {
          ;[...this.variables, ...includeInsideVariables].forEach((matchVariables) => {
            text = text.replaceAll(matchVariables, `<span class="variable-highlight">${matchVariables}</span>`)
          })
          // Handle closing bracket not inside error spans
          const closingBracketRegex = /(?<!<span class="(?:variable-error|variable-error-super)">[^<]*)\]/g
          text = text.replace(closingBracketRegex, `<span class="variable-highlight">]</span>`)
        }
      }
      this.hasVariableErrors = hasVariableErrors
      return text
    },
  },
}
